module.exports = __webpack_public_path__ + "static/media/whiteDownload.ac85c642.svg";